import type { FC } from 'react';
import { Link, Text } from '@chakra-ui/react';
import { FormattedMessage, defineMessage, useIntl } from 'react-intl';
import { PageUrl } from '../../../pages/utils/page-url';
import { useUrl } from '../../../utils/api';

const textStyle = {
    color: '#1A1A1A',
    fontFamily: 'Lato,sans-serif',
    fontSize: '0.75rem',
    fontWeight: '400',
    lineHeight: '1rem',
    letterSpacing: '0.0625rem',
    textTransform: 'capitalize',
};

const goToSiteMap = defineMessage({
    id: 'footer.copyright.site_map.title',
    defaultMessage: 'Go to Site Map',
});

export const Copyright: FC = () => {
    const intl = useIntl();
    const siteMapUrl = useUrl(PageUrl.SITE_MAP);
    return (
        <section data-testid="footer-copyright-container" className="flex xs:mt-6 sm:mt-8">
            <Text sx={textStyle} data-testid="footer.copyright.caption">
                <FormattedMessage
                    id="footer.copyright.caption"
                    defaultMessage="© 2022 Sur la Table, Inc."
                />
            </Text>
            <Text sx={{ ...textStyle, paddingInline: '4px' }}>|</Text>
            <Text
                sx={{ ...textStyle, fontWeight: 700, color: '#1E1E1E' }}
                data-testid="footer.copyright.phone"
            >
                <FormattedMessage id="footer.copyright.phone" defaultMessage="317.559.2041" />
            </Text>
            <Text sx={{ ...textStyle, paddingInline: '4px' }}>|</Text>
            <Link
                href={siteMapUrl}
                title={intl.formatMessage(goToSiteMap)}
                sx={textStyle}
                data-testid="footer.copyright.site_map.caption"
            >
                <FormattedMessage
                    id="footer.copyright.site_map.caption"
                    defaultMessage="Site Map"
                />
            </Link>
        </section>
    );
};
